import React from 'react';
import Swiper from 'react-id-swiper';
import { SectionContainer } from "../../components";
import Hyatt from '../../assets/img/hotels/hyatt.png';
import Fairmont from '../../assets/img/hotels/fairmont.png';
import Hilton from '../../assets/img/hotels/hilton.png';
import InterContinental from '../../assets/img/hotels/intercontinental.png';

import { SliderContainer, SliderItem } from "./styles";

const FeaturedHotels = () => {
  const params = {
    slidesPerView: 3,
    spaceBetween: 40,
    breakpointsInverse: true,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    breakpoints: {
      768: {
        slidesPerView: 8,
      }
    }
  };

  return (
    <SliderContainer>
      <SectionContainer>
        <Swiper {...params}>
          <div>
            <SliderItem>
              <img src={Hyatt} alt="Hyatt" />
            </SliderItem>
          </div>
          <div>
            <SliderItem>
              <img src={Fairmont} alt="Fairmont" />
            </SliderItem>
          </div>
          <div>
            <SliderItem>
              <img src={Hilton} alt="Hilton" />
            </SliderItem>
          </div> 
          <div>
            <SliderItem>
              <img src={InterContinental} alt="Inter Continental" />
            </SliderItem>
          </div>
        </Swiper>
      </SectionContainer>
    </SliderContainer>
  );
};

export default FeaturedHotels;
